<body class="d-flex flex-column min-vh-100">
    <app-navbar></app-navbar>
    <main>
        <router-outlet></router-outlet>
    </main>
    <app-footer class="mt-auto"></app-footer>
</body>